import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M37.4054 21.4038C37.783 21.0422 38 20.5359 38 20.0056C38 19.4752 37.783 18.977 37.4054 18.6073L23.2625 5.10734C22.4911 4.36805 21.2696 4.4002 20.5384 5.17163C19.8071 5.94305 19.8312 7.16448 20.6027 7.89573L31.258 18.077H3.92857C2.85982 18.077 2 18.9368 2 20.0056C2 21.0743 2.85982 21.9341 3.92857 21.9341H31.258L20.5946 32.1073C19.8232 32.8466 19.7991 34.06 20.5304 34.8314C21.2616 35.6029 22.483 35.627 23.2545 34.8957L37.3973 21.3957L37.4054 21.4038Z" })
});
export default SvgArrowRight;
